import React from 'react';
import {
  Page,
  Text,
  Image,
  Document,
  StyleSheet,
  View,
  Font,
} from '@react-pdf/renderer';
import moment from 'moment';

Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf',
    },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf',
      fontWeight: 'bold',
    },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-italic-webfont.ttf',
      fontStyle: 'italic',
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    width: '100%',
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 50,
    fontFamily: 'Roboto',
  },
  header: {
    width: '100%',
    fontSize: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  siteName: {
    fontWeight: 'bold',
  },
  workId: {
    fontWeight: 'bold',
    fontStyle: 'italic',
  },
  table: {
    width: '100%',
  },
  tableRow: {
    flexDirection: 'row',
    width: '100%',
    fontSize: 15,
    borderTop: '1px solid black',
  },
  tableCol1: {
    padding: 5,
    width: '50%',
    borderRight: '1px solid black',
    fontWeight: 'bold',
    borderLeft: '1px solid black',
  },
  tableCol2: {
    padding: 5,
    width: '50%',
    fontWeight: 'bold',
    borderRight: '1px solid black',
  },
  tableBottomCol1: {
    padding: 5,
    width: '50%',
    borderRight: '1px solid black',
    borderLeft: '1px solid black',
    fontWeight: 'bold',
    borderBottom: '1px solid black',
  },
  tableBottomCol2: {
    padding: 5,
    width: '50%',
    fontWeight: 'bold',
    borderBottom: '1px solid black',
    borderRight: '1px solid black',
  },
  comment: {
    width: '100%',
    padding: '20px 0px',
  },
  commentTitle: {
    fontWeight: 'bold',
    fontSize: 15,
  },
  commentText: {
    fontWeight: 400,
    fontSize: 15,
  },
  imagesBlock: {
    flexDirection: 'row',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  image: {
    width: '48.5%',
    objectFit: 'cover',
  },
});

export default ({ data }) => {
  return (
    <Document>
      <Page
        size='A4'
        style={styles.page}
      >
        <View style={styles.header}>
          <Text style={styles.siteName}>mmbaza.uz</Text>
          <Text style={styles.workId}>#ID: {data.workId}</Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableCol1}>
              <Text>Ташкилот номи:</Text>
            </View>
            <View style={styles.tableCol2}>
              <Text>{data?.groupName}</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableCol1}>
              <Text>Ф.И.Ш :</Text>
            </View>
            <View style={styles.tableCol2}>
              <Text>
                {data?.user?.lastName} {data?.user?.firstName}{' '}
                {data?.user?.middleName}
              </Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableCol1}>
              <Text>Туман:</Text>
            </View>
            <View style={styles.tableCol2}>
              <Text>
                {data?.regionName ? data?.regionName : data?.region?.title}
              </Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableCol1}>
              <Text>МФЙ:</Text>
            </View>
            <View style={styles.tableCol2}>
              <Text>
                {data?.objectName ? data?.objectName : data?.object?.title}
              </Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableCol1}>
              <Text>Иш режа номи:</Text>
            </View>
            <View style={styles.tableCol2}>
              <Text>
                {data?.subCategoryName
                  ? data?.subCategoryName
                  : data?.subCategory?.title}
              </Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableCol1}>
              <Text>Бажарилган вақти:</Text>
            </View>
            <View style={styles.tableCol2}>
              <Text>{moment(data?.createdAt).format('DD.MM.YYYY HH:mm')}</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={styles.tableBottomCol1}>
              <Text>Иштирокчилар сони:</Text>
            </View>
            <View style={styles.tableBottomCol2}>
              <Text>{data?.public || 1}</Text>
            </View>
          </View>
        </View>

        <View style={styles.comment}>
          <Text style={styles.commentText}>
            <Text style={styles.commentTitle}>Изоҳ: </Text>
            <Text>{data?.desc}</Text>
          </Text>
        </View>

        <View style={styles.imagesBlock}>
          {data?.media?.map((item, index) => (
            <Image
              key={index}
              style={styles.image}
              src={item.image}
            />
          ))}
        </View>
      </Page>
    </Document>
  );
};
